import React, { useContext, useState, useEffect } from "react";
import "./Form.css";
import PaperInfo from "./PaperInfo";
import FilesUpload from "./FilesUpload";
import validator from "validator";
import AuthorInfo from "./AuthorInfo";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";
import { AiOutlineUserAdd } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { IoMdCloseCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

function Form() {
  const loggedUser = {
    displayName: localStorage.getItem("displayName"),
    email: localStorage.getItem("email"),
    role: localStorage.getItem("role"),
  };

  const removeAuthor = (index) => {
    if (formData.author.length === 1) return;

    const updatedAuthors = formData.author.filter((_, i) => i !== index);
    setFormData({ ...formData, author: updatedAuthors });
  };

  const [page, setPage] = useState(0);
  const [wordLimit, setWordLimit] = useState(0);
  const [isValid, setIsValid] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Static research areas - commented out API calls
  const staticResearchAreas = [
    {
      mainDomain: "Biomedical Engineering and Bioscience",
      subDomains: [
        "Advances in medical imaging technology",
        "Biomedical and health informatics",
        "Biomedical signal processing",
        "Biorobotics and biomachines"
      ]
    },
    {
      mainDomain: "Chemical Engineering and Material Science",
      subDomains: [
        "Biomaterials and bio-sensors",
        "Chemical process technology",
        "Chemical safety and management",
        "Emerging technologies in chemical engineering",
        "Nanotechnology and application"
      ]
    },
    {
      mainDomain: "Computational Intelligence and Applications",
      subDomains: [
        "Artificial Intelligence and Machine Learning",
        "Cyber Security",
        "Data Science and Statistics",
        "Green software engineering and sustainable computing",
        "Intelligent computing",
        "Smart Agriculture and IoT"
      ]
    },
    {
      mainDomain: "Electrical, Electronics, and Communication Engineering",
      subDomains: [
        "Application of power electronics",
        "Distributed power generation and Smart power grid",
        "Electronics and communication",
        "Power system planning and optimization",
        "Renewable Energy Application",
        "Sustainable Energy Management",
        "Waste-to-energy"
      ]
    },
    {
      mainDomain: "Environmental Science and Climate Change",
      subDomains: [
        "Air, water, and soil quality",
        "Biodiversity and climate action",
        "Disaster and risk management associated with climate change",
        "Emerging contaminants and remedial techniques",
        "Green technologies for sustainable solutions",
        "Remote sensing and resource monitoring",
        "Sustainable technology for environmental protection"
      ]
    },
    {
      mainDomain: "Mechanical, Industrial and Production Engineering",
      subDomains: [
        "Advanced machinery and automation",
        "Cross cutting issues in industrial development",
        "Innovative manufacturing technologies",
        "Intelligent robotics and control",
        "Product control and management",
        "Smart supply chain management"
      ]
    },
    {
      mainDomain: "Petroleum, Mining, and Ocean Technology",
      subDomains: [
        "Geology, mineralogy, and exploration geochemistry",
        "Marine plastic pollution",
        "Mining engineering and technology development",
        "Ocean technology and blue economy",
        "Petroleum geoscience and technology",
        "Non-renewable energy"
      ]
    },
    {
      mainDomain: "Textile Engineering and Sustainable Technology",
      subDomains: [
        "Composite materials and industrial textiles",
        "Fiber science and technology",
        "Life cycle analysis and sustainability",
        "Modern spinning and weaving technology",
        "Sustainable dyes and chemical management",
        "Textile chemical and manufacturing processes"
      ]
    },
    {
      mainDomain: "Nuclear, Plasma, Radiological Engineering",
      subDomains: [
        "Nuclear fusion, fission",
        "Plasma processing and plasma treatment",
        "Thin Film Deposition",
        "Material Interaction, coating and surface technology"
      ]
    }
  ];
  
  const [researchAreas, setResearchAreas] = useState(staticResearchAreas);
  const [formData, setFormData] = useState({
    title: "",
    abstract: "",
    keywords: "",
    presentationType: "",
    fileURL: "",
    paperDomain1: "",
    paperDomain2: "",
    paperDomain3: "",
    role: loggedUser.role,
    status: "Submitted",
    author: [
      {
        firstName: loggedUser?.displayName
          ? loggedUser?.displayName.split(" ")[0]
          : "",
        lastName: loggedUser?.displayName
          ? loggedUser?.displayName.split(" ")[1]
          : "",
        email: loggedUser?.email,
        affiliation: "",
        country: "",
        state: "",
        city: "",
        postCode: "",
        street: "",
        line1: "",
        line2: "",
      },
    ],
  });

  // Commented out API call for research areas
  // useEffect(() => {
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/get-cutomize-domains`
  //     )
  //     .then((response) => {
  //       setResearchAreas(response.data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching research areas:", error);
  //     });
  // }, []);

  const FormTitles = [
    "Provide Paper Info",
    "Provide Author Info",
    "Upload Your Files",
  ];
  let navigate = useNavigate();

  const addFields = () => {
    let object = {
      firstName: "",
      lastName: "",
      email: "",
      affiliation: "",
      country: "",
      state: "",
      city: "",
      postCode: "",
      street: "",
      line1: "",
      line2: "",
    };
    let author = [...formData["author"], object];
    setFormData({ ...formData, author });
  };

  const handleFormChange = (event, index) => {
    let data = [...formData["author"]];
    data[index][event.target.name] = event.target.value;
  };

  const handleSubmit = () => {
    if (!formData.fileURL) {
      Swal.fire({
        icon: "error",
        title: "No file selected",
        text: "Please select a file to upload.",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#008000",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes !",
    }).then((result) => {
      if (result.isConfirmed) {
        // Start loading
        setIsSubmitting(true);
        
        // Show loading alert
        Swal.fire({
          title: "Submitting Paper...",
          text: "Please wait while we process your submission",
          icon: "info",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const Data = new FormData();
        Data.append("title", formData.title);
        Data.append("abstract", formData.abstract);
        Data.append("keywords", formData.keywords);

        Data.append("presentationType", formData.presentationType);
        Data.append("file", formData.fileURL);
        Data.append("role", formData.role);
        Data.append("status", formData.status);

        const paperDomains = [
          formData.paperDomain1,
          formData.paperDomain2,
          formData.paperDomain3,
        ];

        Data.append("paperDomains", JSON.stringify(paperDomains));
        formData.author.forEach((element, index) => {
          Data.append(`author[${index}][firstName]`, element.firstName);
          Data.append(`author[${index}][lastName]`, element.lastName);
          Data.append(`author[${index}][email]`, element.email);
          Data.append(`author[${index}][affiliation]`, element.affiliation);
          Data.append(`author[${index}][country]`, element.country);
          Data.append(`author[${index}][state]`, element.state);
          Data.append(`author[${index}][city]`, element.city);
          Data.append(`author[${index}][postCode]`, element.postCode);
          Data.append(`author[${index}][street]`, element.street);
          Data.append(`author[${index}][line1]`, element.line1);
          Data.append(`author[${index}][line2]`, element.line2);
        });

        //check
        for (let pair of Data.entries()) {
          // console.log(pair[0] + ": ", pair[1]);
        }

        axios
          .post(
            `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/submit/upload`,
            Data
          )
          .then(function (response) {
            setIsSubmitting(false);
            Swal.fire("Uploaded!", "Successfully Submitted!", "success");
            if (loggedUser.role === "author") {
              navigate("/author/history");
            } else if (loggedUser.role === "reviewer") {
              navigate("/");
            } else {
              navigate("/");
            }
          })
          .catch(function (error) {
            setIsSubmitting(false);
            const errorMessage =
              error.response?.data?.message || "Paper Submission Failed";

            Swal.fire({
              icon: "error",
              title: errorMessage,
              showConfirmButton: false,
              timer: 1500,
            });
          });
      }
    });
  };

  const PageDisplay = () => {
    if (page === 0) {
      return (
        <PaperInfo
          formData={formData}
          setFormData={setFormData}
          wordLimit={wordLimit}
          setWordLimit={setWordLimit}
          setIsValid={setIsValid}
          isValid={isValid}
        />
      );
    } else if (page === 1) {
      return (
        <div className="form-author-section">
          {formData?.author?.map((specific, index) => (
            <div key={index} className="form-author-block">
              <AuthorInfo
                formData={formData}
                setFormData={setFormData}
                specific={specific}
                index={index}
                handleFormChange={handleFormChange}
              />
              {index > 0 && (
                <button
                  className="form-remove-author-btn"
                  onClick={() => removeAuthor(index)}
                >
                  <MdDelete className="form-add-icon" />
                  <span>Remove Author</span>
                </button>
              )}
            </div>
          ))}
          <div className="form-add-author">
            <button onClick={addFields} className="form-add-author-btn">
              <AiOutlineUserAdd className="form-add-icon" />
              <span>Add More Author</span>
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <FilesUpload
          formData={formData}
          setFormData={setFormData}
          researchAreas={researchAreas}
        />
      );
    }
  };

  return (
    <div className="form-main-container">
      {/* Deadline Notice Banner */}
      <div className="form-deadline-notice">
        <div className="form-deadline-notice-content">
          <div>
            <p className="form-deadline-text">Paper Submission is Closed</p>
            <p className="form-deadline-subtext">
              The submission deadline has passed. Thank you for your interest.
            </p>
          </div>
        </div>
      </div>

      <div className="form-content-wrapper">
        {/* Header Section */}
        <div className="form-header">
          <div className="form-header-content">
            <h1 className="form-title">{FormTitles[page]}</h1>
            <p className="form-subtitle">
              {page === 0 &&
                "Please provide your paper information and details"}
              {page === 1 && "Add author information for your research paper"}
              {page === 2 && "Upload your research paper and select domains"}
            </p>
          </div>

          {/* Progress Bar */}
          <div className="form-progress-container">
            <div className="form-progress-bar">
              <div
                className="form-progress-fill"
                style={{
                  width: page === 0 ? "33.33%" : page === 1 ? "66.67%" : "100%",
                }}
              ></div>
            </div>
            <div className="form-progress-steps">
              <div
                className={`form-progress-step ${page >= 0 ? "active" : ""}`}
              >
                <span className="form-step-number">1</span>
                <span className="form-step-label">Paper Info</span>
              </div>
              <div
                className={`form-progress-step ${page >= 1 ? "active" : ""}`}
              >
                <span className="form-step-number">2</span>
                <span className="form-step-label">Author Info</span>
              </div>
              <div
                className={`form-progress-step ${page >= 2 ? "active" : ""}`}
              >
                <span className="form-step-number">3</span>
                <span className="form-step-label">Upload Files</span>
              </div>
            </div>
          </div>
        </div>

        {/* Form Body */}
        <div className="form-body">
          <div className="form-body-content">{PageDisplay()}</div>
        </div>

        {/* Footer Navigation */}
        <div className="form-footer">
          <div className="form-navigation">
            <button
              className="form-nav-btn form-nav-prev"
              disabled={page === 0}
              onClick={() => setPage((currPage) => currPage - 1)}
            >
              <IoIosArrowBack className="form-nav-icon" />
              <span>Previous</span>
            </button>

            <button
              className="form-nav-btn form-nav-next"
              onClick={() => {
                Swal.fire({
                  icon: "error",
                  title: "Paper Submission Deadline is Over!",
                  text: "The submission deadline has passed. Thank you for your interest.",
                  showConfirmButton: true,
                  confirmButtonColor: "#ef4444",
                });
              }}
              disabled={false}
            >
              <span>
                {page === FormTitles.length - 1 ? "Submit Paper" : "Next Step"}
              </span>
              {page !== FormTitles.length - 1 && (
                <MdOutlineArrowForwardIos className="form-nav-icon" />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Form;
